export default __webpack_public_path__ + "static/media/Scorbit_Space.3ea46245.png";